export const KILLSHOT_ORGANIZATION_COOKIE = 'killshot_organization';
